import { render, staticRenderFns } from "./Organogram.vue?vue&type=template&id=5807a6db&scoped=true"
import script from "./Organogram.vue?vue&type=script&lang=js"
export * from "./Organogram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5807a6db",
  null
  
)

export default component.exports